import React from 'react';
import Header from '../../../components/layout/Header';
import AdvancedSearch from '../../../components/leads/AdvancedSearch';
import LeadTable from '../../../components/leads/LeadTable';
import useLeads from '../../../hooks/useLeads';

const LockedLeads = () => {
  const { leads, loading, pagination, filters, setFilters, onSearch, onPageChange, refresh, exportAll } = useLeads({ is_locked: true });

  return (
    <div>
      <Header title="Locked Leads" subtitle={`${pagination.total || 0} locked leads`} />
      <div className="page">
        <AdvancedSearch filters={filters} setFilters={setFilters} onSearch={onSearch} />
        <LeadTable
          leads={leads}
          loading={loading}
          pagination={pagination}
          onPageChange={onPageChange}
          onRefresh={refresh}
          onExportAll={exportAll}
          showLeadType
          emptyMessage="No locked leads"
        />
      </div>
    </div>
  );
};
export default LockedLeads;
